module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg login-bg",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg lead"
  }, [_vm._v("An email has been sent for verification. Please go to your inbox and click the link to validate your newly created account.")]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_c('a', {
    on: {
      "click": _vm.handleSendEmail
    }
  }, [_vm._v("\n                Re-send email verification.\n                "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendingVerificationEmail),
      expression: "sendingVerificationEmail"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "m-b-lg"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'auth.logout'
      }
    }
  }, [_vm._v("Return to login screen")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v("Account Created")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swal2-show"
  }, [_c('div', {
    staticClass: "swal2-icon swal2-success swal2-animate-success-icon",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "swal2-success-circular-line-left",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-tip swal2-animate-success-line-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-long swal2-animate-success-line-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-ring"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-fix",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-circular-line-right",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-44f9698e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterSuccess.vue
// module id = 982
// module chunks = 0